module.exports = __webpack_public_path__ + "assets/img/news (8).6e055092.png";